import React, { useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { QRCodeCanvas } from "qrcode.react";
import { getTableQrUrl, getTableQrFileName, downloadCanvasAsPng } from "utils/tableQr";

import { useTranslation } from "react-i18next";

export default function TableQrModal({ table, show, handleClose }) {
  const { t } = useTranslation();

  const wrapperRef = useRef(null);
  const qrUrl = table ? getTableQrUrl(table.uuid) : "";

  const download = () => {
    const canvas = wrapperRef.current && wrapperRef.current.querySelector("canvas");
    if (canvas) downloadCanvasAsPng(canvas, getTableQrFileName(table, "png"));
  };

  return (
    <Modal show={show} onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ margin: 0 }}>{table ? [table.name, table.regionName].filter(Boolean).join(" - ") : ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: "center" }}>
        {table ? (
          <>
            <div ref={wrapperRef}>
              <QRCodeCanvas value={qrUrl} size={512} includeMargin={true} style={{ width: "256px", height: "256px" }} />
            </div>
            <a href={qrUrl} target="_blank" rel="noopener noreferrer" className="text-muted small" style={{ wordBreak: "break-all" }}>
              {qrUrl}
            </a>
          </>
        ) : null}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="default" onClick={handleClose}>
          {t("common.actions.cancel")}
        </Button>
        <Button className="btn-wd btn-outline" variant="success" onClick={download} disabled={!table}>
          <i className="fa fa-download" />
          <span className="ml-1">{t("common.actions.downloadQr")}</span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
